import { Box, Tooltip, Typography } from '@mui/material';
import Image from 'src/components/Image';

// The notepad icon the tables use to say a row has a note, with the note itself on hover. Nothing
// renders without a note.
const NoteTooltip = ({ note, size = 14 }) =>
  note ? (
    <Tooltip
      arrow
      componentsProps={{ tooltip: { sx: { bgcolor: '#3F3F3F', maxWidth: 480 } } }}
      title={
        <Typography sx={{ color: '#F3F4F6', fontSize: '0.72rem', whiteSpace: 'pre-wrap' }}>
          {note}
        </Typography>
      }>
      <Box
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        onClick={event => event.stopPropagation()}>
        <Image src="/static/icons/notes-notepad.svg" alt="Note" width={size} height={size} />
      </Box>
    </Tooltip>
  ) : null;

export default NoteTooltip;
